module.exports = __webpack_public_path__ + "img/credit-card.b488f172.svg";